import { useNavigate } from "react-router-dom";
import { api } from "../../api/api";
import { useEffect, useState } from "react";
import { DateTime } from "luxon";
import { Toast } from "../../utils/Toast";
import { LIST_TYPE_COMPANY } from "../../utils/constantes";
import ReactInputMask from "react-input-mask";
import { CiLock, CiMail, CiPhone } from "react-icons/ci";
import { HiOutlineBuildingStorefront } from "react-icons/hi2";
import { LuArrowRight, LuBadgeCheck } from "react-icons/lu";
import { MdOutlineBadge } from "react-icons/md";
import CpfCnpj from "@react-br-forms/cpf-cnpj-mask";
import "../Login/style.css";
import "./style.css";

export function RegisterPage() {
  const navigate = useNavigate();

  const [infoRegister, setInfoRegister] = useState({
    email: '',
    password: '',
    fullName: '',
    phone: '',
    cpfCnpj: '',
    birthDate: '',
    cep: '',
    city: '',
    uf: '',
    address: '',
    district: '',
    number: '',
    complement: '',
    timeZone: DateTime.local().zoneName,
    nameResponsible: '',
    cpfResponsible: '',
    phoneResponsible: '',
    area: null
  })

  const sectionCards = [
    "Configuração rápida",
    "Teste gratuito",
    "Suporte para operação diária"
  ];

  async function register() {
    if (
      !infoRegister.fullName ||
      !infoRegister.cpfCnpj ||
      !infoRegister.email ||
      !infoRegister.password ||
      !infoRegister.area ||
      !infoRegister.nameResponsible ||
      !infoRegister.cpfResponsible ||
      !infoRegister.phoneResponsible
    ) {
      return Toast.warning("Todos campos são obrigatórios")
    }

    try {
      await api.post('/users/register', infoRegister)
      Toast.message("Registro efetuado com sucesso, você será redirecionado para o login.")
      navigate('/')
    } catch (error) {
      Toast.error(error?.response?.data?.message || "Não foi possível concluir o cadastro.")
    }
  }

  useEffect(() => {
    if (localStorage.getItem('access_token')?.length > 0) {
      window.location.href = '/home'
    } else {
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
    }
  }, [])




  return (
    <div className="container-login register-page-shell">
      <div className="left-area register-highlight-panel">
        <div>
          <div className="register-brand-row">
            <div className="content-img-login">
              <img className="logo-login" src="./logo-sem-fundo.png" alt="Logo Unledu" />
            </div>

            <p className="register-brand-name">Unledu</p>
          </div>

          <div className="register-highlight-copy">
            <span className="register-highlight-badge">Teste gratuito</span>
            <h1>Comece seu cadastro e coloque sua operação para rodar em poucos minutos.</h1>
            <p>
              Centralize pedidos, organize atendimento e tenha uma estrutura mais profissional desde o primeiro acesso.
            </p>

            <div className="register-chip-list">
              {sectionCards.map((item) => (
                <div key={item} className="register-chip">
                  <LuBadgeCheck size={16} />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="register-footer-note">
          <p>Cadastro pensado para restaurantes, lanchonetes e operações locais que precisam vender melhor.</p>
        </div>
      </div>

      <div className="right-area register-form-panel">
        <div className="register-form-wrapper">
          <div className="register-form-header">
            <p className="register-eyebrow">Criar conta</p>
            <h2>Abra sua conta na Unledu</h2>
            <p>Preencha os dados abaixo para liberar seu acesso de teste e configurar sua operação.</p>
          </div>

          <div className="register-card">
            <form className="register-form-grid">
              <div className="register-section-header">
                <span>Informações do estabelecimento</span>
              </div>

              <div className="register-field-group register-field-group-full">
                <label htmlFor="name" className="register-label">Empresa</label>
                <div className="content-input register-input-shell">
                  <div className="register-input-icon">
                    <HiOutlineBuildingStorefront size={18} />
                  </div>
                  <input
                    type="text"
                    onChange={(e) => setInfoRegister(state => ({ ...state, fullName: e.target.value }))}
                    value={infoRegister.fullName}
                    className="form-control default-input-login register-input"
                    id="name"
                    placeholder="Nome da empresa"
                  />
                </div>
              </div>

              <div className="register-field-group">
                <label htmlFor="cpfcnpj" className="register-label">CPF/CNPJ</label>
                <div className="content-input register-input-shell">
                  <div className="register-input-icon">
                    <MdOutlineBadge size={18} />
                  </div>
                  <CpfCnpj
                    className="form-control default-input-login register-input"
                    value={infoRegister?.cpfCnpj ?? ''}
                    onChange={(e) => setInfoRegister(state => ({ ...state, cpfCnpj: e.target.value }))}
                  />

                </div>
              </div>

              <div className="register-field-group">
                <label htmlFor="phone" className="register-label">Telefone</label>
                <div className="content-input register-input-shell">
                  <div className="register-input-icon">
                    <CiPhone size={18} />
                  </div>
                  <ReactInputMask
                    id="phone"
                    mask="(99) 99999-9999"
                    className="form-control default-input-login register-input"
                    value={infoRegister.phone}
                    onChange={(e) => setInfoRegister(state => ({ ...state, phone: e.target.value }))}
                    placeholder="(00) 00000-0000"
                  />
                </div>
              </div>

              <div className="register-field-group">
                <label htmlFor="email" className="register-label">E-mail</label>
                <div className="content-input register-input-shell">
                  <div className="register-input-icon">
                    <CiMail size={18} />
                  </div>
                  <input
                    type="email"
                    onChange={(e) => setInfoRegister(state => ({ ...state, email: e.target.value }))}
                    value={infoRegister.email}
                    className="form-control default-input-login register-input"
                    id="email"
                    placeholder="seu@email.com"
                  />
                </div>
              </div>

              <div className="register-field-group">
                <label htmlFor="password" className="register-label">Senha</label>
                <div className="content-input register-input-shell">
                  <div className="register-input-icon">
                    <CiLock size={18} />
                  </div>
                  <input
                    onChange={(e) => setInfoRegister(state => ({ ...state, password: e.target.value }))}
                    value={infoRegister.password}
                    type="password"
                    className="form-control default-input-login register-input"
                    id="password"
                    placeholder="Crie uma senha"
                  />
                </div>
              </div>

              <div className="register-field-group">
                <label htmlFor="area" className="register-label">Área de atuação</label>
                <select
                  id="area"
                  value={infoRegister.area || ""}
                  onChange={(e) => setInfoRegister(state => ({ ...state, area: e.target.value || null }))}
                  className="form-select register-select"
                >
                  <option value="">Selecione</option>
                  {LIST_TYPE_COMPANY.map(value => {
                    return (
                      <option key={value} value={value}>{value}</option>
                    )
                  })}
                </select>
              </div>

              <div className="register-section-header register-section-header-spaced">
                <span>Informações do responsável</span>
              </div>

              <div className="register-field-group register-field-group-full">
                <label htmlFor="responsible-name" className="register-label">Nome</label>
                <input
                  id="responsible-name"
                  maxLength={100}
                  onChange={(e) => setInfoRegister(state => ({ ...state, nameResponsible: e.target.value }))}
                  value={infoRegister.nameResponsible}
                  type="text"
                  className="form-control register-simple-input"
                  placeholder="Nome do responsável"
                />
              </div>

              <div className="register-field-group">
                <label htmlFor="responsible-cpf" className="register-label">CPF</label>
                <ReactInputMask
                  id="responsible-cpf"
                  mask="999.999.999-99"
                  className="form-control register-simple-input"
                  value={infoRegister.cpfResponsible ?? ''}
                  onChange={(e) => setInfoRegister(state => ({ ...state, cpfResponsible: e.target.value }))}
                  placeholder="000.000.000-00"
                />
              </div>

              <div className="register-field-group">
                <label htmlFor="responsible-phone" className="register-label">Celular</label>
                <ReactInputMask
                  id="responsible-phone"
                  mask="(99) 9 9999-9999"
                  className="form-control register-simple-input"
                  value={infoRegister.phoneResponsible}
                  onChange={(e) => setInfoRegister(state => ({ ...state, phoneResponsible: e.target.value }))}
                  placeholder="(00) 0 0000-0000"
                />
              </div>

              <div className="register-actions">
                <button
                  type="button"
                  className="btn btn-lg btn-dark-blue w-100 register-primary-button"
                  onClick={async (e) => {
                    e.preventDefault()
                    await register()
                  }}
                >
                  Criar conta
                  <LuArrowRight style={{ marginLeft: '0.5rem' }} />
                </button>

                <button
                  type="button"
                  className="btn register-secondary-button"
                  onClick={(e) => {
                    e.preventDefault()
                    navigate('/')
                  }}
                >
                  Voltar para o login
                </button>
              </div>
            </form>
          </div>

          <p className="register-bottom-copy">Ao continuar, você inicia seu acesso de demonstração para testar a plataforma.</p>
        </div>
      </div>
    </div >
  )
}